import React, { useEffect, useRef, useState } from "react";
import {
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardContent,
  IonImg,
  IonSpinner,
  IonText,
  IonButton,
  IonModal,
  IonItem,
  IonLabel,
  IonInput,
  IonDatetime,
  IonButtons,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonIcon,
  IonToast,
} from "@ionic/react";
import { calendarOutline, trashOutline } from "ionicons/icons";
import { useTranslation } from "react-i18next";

import { useDispatch, useSelector } from "react-redux";
import {
  addCommunityEvent,
  fetchCommunityEvents,
  fetchEvents,
  removeCommunityEvent,
} from "../../redux/actions/canadaNowActions";
import "./RotatingEventsCard.css";
import Avatar from "../../components/avatar/Avatar";
import { Link } from "react-router-dom";
const ShowpassRotatingCard = ({ city = "Vancouver" }) => {
  const [showToast, setShowToast] = useState({ show: false, message: "" });
  const { events, loading, communityEvents } = useSelector(
    (state) => state.canadaNow,
  );
  const { data: user } = useSelector((state) => state.currentProfile);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const fileInputRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null); // To store the actual File
  const [previewUrl, setPreviewUrl] = useState(""); // To store the UI preview
  // --- LOCAL STATE ---
  const [showModal, setShowModal] = useState(false);
  const [newEvent, setNewEvent] = useState({
    name: "",
    image: "",
    date: new Date().toISOString(),
    location: "",
  });
  const handleDelete = (eventId) => {
    if (
      window.confirm(
        t("confirmDelete", "Are you sure you want to delete this event?"),
      )
    ) {
      dispatch(removeCommunityEvent(eventId));
    }
  };
  useEffect(() => {
    if (!events && !loading) {
      dispatch(fetchEvents(city));
    }
    dispatch(fetchCommunityEvents());
  }, [dispatch, city]);

  // --- HANDLERS ---
  const handleInputChange = (e, field) => {
    setNewEvent({ ...newEvent, [field]: e.detail.value });
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file); // Save raw file for FormData
      setPreviewUrl(URL.createObjectURL(file)); // Save local URL for preview
    }
  };
  const handleAddEvent = async () => {
    // 1. Define required fields
    const { name, date, city, venue } = newEvent;

    // 2. Check for missing fields
    if (!name || !date || !city || !venue || !selectedFile) {
      setShowToast({
        show: true,
        type: "error", // Added type
        message: t(
          "allFieldsRequired",
          "Please fill in all fields and upload an image.",
        ),
      });
      return; // Stop the function here
    }
    if (name.length < 2 || name.length > 100) {
      setShowToast({
        show: true,
        type: "error",
        message: "Event name must be between 3 and 100 characters",
      });
      return;
    }
    const formData = new FormData();
    formData.append("name", newEvent.name);
    formData.append("date", newEvent.date);
    formData.append("city", newEvent.city); // Map to 'city'
    formData.append("venue", newEvent.venue); // Send the venue name string
    formData.append("image", selectedFile);

    await dispatch(addCommunityEvent(formData)).unwrap();

    setShowModal(false);
    resetForm();
    setShowToast({
      show: true,
      type: "success",
      message: "Event created successfully",
    });
  };

  const resetForm = () => {
    setNewEvent({
      name: "",
      image: "",
      date: new Date().toISOString(),
      city: "",
      venue: "", // New field for the venue name
    });
    setSelectedFile(null);
    setPreviewUrl("");
  };

  // Combine official events and community events from Redux
  // const combinedEvents = [...(communityEvents || []), ...(events || [])];
  // Combine official events and community events, then sort by date descending
  const combinedEvents = [...(communityEvents || []), ...(events || [])].sort(
    (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime(),
  );
  if (loading && !events) return <IonSpinner className="events-spinner" />;

  return (
    <div className="post__side--right post poppins showpass-rotating-card-container">
      <IonCardHeader className="events-header-container">
        <IonCardTitle className="local-header events-header-title">
          {/* {"📅 " + t("events")} */}
          <IonIcon
            icon={calendarOutline}
            style={{ transform: "translateY(2px)" }}
          />{" "}
          {t("events")}
        </IonCardTitle>
        <IonButton
          size="small"
          className="btn-add-event"
          onClick={() => setShowModal(true)}
        >
          + {t("addEvent", "Add Event")}
        </IonButton>
      </IonCardHeader>

      {/* --- ADD EVENT MODAL --- */}
      <IonModal isOpen={showModal} onDidDismiss={() => setShowModal(false)}>
        <IonHeader>
          <IonToolbar>
            <IonTitle>{t("addNewEvent", "Add New Event")}</IonTitle>
            <IonButtons slot="end">
              <IonButton onClick={() => setShowModal(false)}>
                {t("close", "Close")}
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent className="ion-padding showpass-modal-content">
          <IonItem>
            <IonLabel position="stacked">
              {t("eventName", "Event Name")}
            </IonLabel>
            <IonInput
              value={newEvent.name}
              onIonChange={(e) => handleInputChange(e, "name")}
              placeholder="e.g. Local Tech Meetup"
            />
          </IonItem>
          <IonItem lines="none" className="image-upload-wrapper">
            <IonLabel position="stacked" className="image-upload-label">
              {t("posterImage", "Poster image")}
            </IonLabel>

            {/* Hidden native file input */}
            <input
              type="file"
              accept="image/*"
              onChange={handleImageUpload}
              ref={fileInputRef}
              style={{ display: "none" }}
            />

            {/* Styled Ionic Button to trigger the hidden input */}
            <IonButton
              fill="outline"
              // color="danger"
              className="upload-image-btn"
              onClick={() => fileInputRef.current?.click()}
            >
              📷{" "}
              {newEvent.image
                ? t("changeImage", "Change Image")
                : t("chooseImage", "Choose Image")}
            </IonButton>

            {(previewUrl || newEvent.image) && (
              <img
                src={previewUrl || newEvent.image}
                alt="Preview"
                className="image-upload-preview"
                style={{
                  marginTop: "16px",
                  borderRadius: "8px",
                  maxHeight: "200px",
                }}
              />
            )}
          </IonItem>
          {/* Venue Name Input */}
          <IonItem>
            <IonLabel position="stacked">{t("venue", "Venue Name")}</IonLabel>
            <IonInput
              value={newEvent.venue}
              onIonChange={(e) => handleInputChange(e, "venue")}
              placeholder="e.g. Rogers Arena"
            />
          </IonItem>

          {/* City Input */}
          <IonItem>
            <IonLabel position="stacked">{t("city", "City")}</IonLabel>
            <IonInput
              value={newEvent.city}
              onIonChange={(e) => handleInputChange(e, "city")}
              placeholder="e.g. Vancouver"
            />
          </IonItem>
          <IonItem>
            <IonLabel position="stacked">{t("date", "Date & Time")}</IonLabel>
            <IonDatetime
              value={newEvent.date}
              onIonChange={(e) => handleInputChange(e, "date")}
              presentation="date-time"
            />
          </IonItem>
          <IonButton
            expand="block"
            // color="danger"
            className="ion-margin-top submit-event-btn"
            onClick={handleAddEvent}
            disabled={!newEvent.name || !newEvent.date}
          >
            {t("submit", "Submit Event")}
          </IonButton>
          {/* Toast Notification */}
          <IonToast
            isOpen={showToast.show}
            onDidDismiss={() => setShowToast({ ...showToast, show: false })}
            message={showToast.message}
            duration={5000}
            color={showToast.type === "success" ? "success" : "danger"}
            buttons={[{ text: "OK", role: "cancel" }]}
          />
        </IonContent>
      </IonModal>

      {/* --- EVENT LIST --- */}
      {!combinedEvents.length ? (
        <IonCard className="no-events-card">
          <IonCardHeader>
            <IonCardTitle>🇨🇦 {t("noEventsFound")}</IonCardTitle>
          </IonCardHeader>
          <IonCardContent>
            {t(
              "noEventsFoundContent",
              "Couldn’t find any events for {{city}} right now.",
              { city },
            )}
          </IonCardContent>
        </IonCard>
      ) : (
        combinedEvents.map((item, index) => (
          <IonCard key={item.id || index} className={`ion-padding event-card`}>
            {item.image && (
              <IonImg
                src={item.image}
                alt={item.name}
                className="event-card-image"
              />
            )}
            <IonCardHeader>
              <IonCardTitle className="poetsen event-card-title">
                🎫 {item.name}
              </IonCardTitle>
              {/* Show author if it exists (for community events) */}
              {item.author?._id && (
                <Link
                  className="events-flex"
                  to={`/profile/${item.author.username}`}
                >
                  <Avatar
                    avatar={item.author.avatar}
                    username={item.author.username}
                  />
                  <IonText color="medium">
                    <p style={{ fontSize: "0.8rem" }}>{item.author.username}</p>
                  </IonText>
                </Link>
              )}
              {item.author && !item.author._id && (
                <IonText color="medium">
                  <p style={{ fontSize: "0.8rem" }}>
                    By: {item.author.username}
                  </p>
                </IonText>
              )}
              <IonCardContent className="poetsen event-card-details">
                <IonIcon
                  icon={calendarOutline}
                  style={{ transform: "translateY(2px)" }}
                />{" "}
                {item.date &&
                  new Date(item.date).toLocaleString("en-CA", {
                    weekday: "short",
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                    hour: "numeric",
                    minute: "2-digit",
                  })}{" "}
                <br />
                📍 {item.venue?.name}, {item.city}
              </IonCardContent>
            </IonCardHeader>
            <IonCardContent className="poetsen">
              <div className="events-flex">
                <IonText>
                  <p>{item.isCustom ? "Community Event" : "Show Pass"}</p>
                </IonText>
                {/* Show delete button only for Admins */}
                {/* Show delete button only for Admins or the Event Owner */}
                {user?._id && item.author?._id === user._id && (
                  <IonButton
                    color="danger"
                    fill="clear"
                    onClick={() => handleDelete(item._id)}
                    title={t("deleteEvent", "Delete Event")}
                  >
                    <IonIcon slot="icon-only" icon={trashOutline} />
                  </IonButton>
                )}
              </div>
              {item.url !== "#" && (
                <a
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="view-event-button"
                >
                  {t("viewEvent")} →
                </a>
              )}
            </IonCardContent>
          </IonCard>
        ))
      )}
    </div>
  );
};

export default ShowpassRotatingCard;
